/**
 * Compliance Layout
 * Wraps compliance management routes with shared data provider
 * Ensures single API call for all compliance-related pages
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { ComplianceDataProvider } from '@/contexts';

const ComplianceLayout: React.FC = () => {
  return (
    <ComplianceDataProvider>
      <Outlet />
    </ComplianceDataProvider>
  );
};

export default ComplianceLayout;
